module.exports = __webpack_public_path__ + "img/H2.4fb48d3b.png";